import React, { useEffect, useState } from "react";
import HomeSlider from "../components/HomeSlider";
import EventCard from "../components/EventCard";
import AdvertisementSlider from "../components/AdvertisementSlider";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getAllEventsApi } from "../hooks/ApisContainer/Event";
import LottiLoader from "../components/shared/Loader/LottiLoader";
import useToastContext from "../hooks/useToastContext";
import NoDataFound from "../components/shared/Loader/NoDataAnimation";

const Home = () => {
  const navigate = useNavigate();
  const notification = useToastContext();

  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");

  const [loader, setLoader] = useState(false)
  const [upcomingEvent, setUpcomingEvent] = useState([])
  const [pastEvent, setPastEvent] = useState([])

  const fetchedGetEvents = () => {
    getAllEventsApi({}, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setUpcomingEvent(response?.upcomingEvent);
        setPastEvent(response?.pastEvent);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0)
    fetchedGetEvents()
  }, [])

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      } else {
        navigate("/dashboard");
      }
    }
  }, [Token]);
  return (
    <div>
      <HomeSlider />
      {/* <AdvertisementSlider/> */}
      <div className="events-home-sec">
        {loader ? (<Container className="d-flex justify-content-center align-items-center default-back">
          <span>
            <LottiLoader height={120} width={120} loader={true} />
          </span>
        </Container>) : (<Container>
          {upcomingEvent && upcomingEvent?.length > 0 && <div className="upcoming-event-sec">
            <EventCard title="Upcoming Events" events={upcomingEvent} />
          </div>}
          {pastEvent && pastEvent?.length > 0 && <div className="past-event-sec">
            <EventCard title="Past Events" events={pastEvent} />
          </div>}
        </Container>)}
        {!loader && upcomingEvent?.length == 0 && pastEvent?.length == 0 && (
          <NoDataFound height={200} width={200} firstMessage="No Events there." />
        )}
      </div>
    </div>
  );
};

export default Home;
